import type { DeepPartial } from '@luna/utils-ts';

import type { ContactDataManagementFeatureConfig } from './type';

export const contactDataManagement: DeepPartial<ContactDataManagementFeatureConfig> = {
    address: {
        cityFieldDisabled: true,
        maxCityLength: 40,
        maxStreetLength: 40,
        streetNumberField: true,
    },
    addressDeleteDelayAlert: true,
    mainContactSetting: true,
    phone: {
        summaryFormat: 'INTERNATIONAL',
    },
    alwaysSetNewContactAsMain: true,
};
